import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllCustomers } from "../../redux/actions/customerAction";
import { RiAccountCircle2Fill, RiMailUnreadFill, RiCalendarCheckFill, RiEdit2Line, RiDeleteBin6Line, RiEyeLine } from "react-icons/ri";
import { CustomDataTable } from "../../components";
import { TbDeviceMobile } from "react-icons/tb";
import { IMG } from "../../constant";

const Customers = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.admin);
  const { customers, loader, errors } = useSelector((state) => state.customers);

  console.log(customers)

  useEffect(() => {
    if (token) {
      dispatch(fetchAllCustomers({ token }));
    }
  }, [dispatch, token]);

  const handleView = (id) => console.log("View Customer:", id);
  const handleEdit = (id) => console.log("Edit Customer:", id);
  const handleDelete = (id) => console.log("Delete Customer:", id);

  const formattedDate = (dateString) => {
    // Format date: Sun, Apr 6, 2025
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    console.log("FormattedDate", createdAt)
    return createdAt.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }

  const formattedTime = (dateString) => {
    // Format time: 06:33 PM
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    return createdAt.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  const columns = [
    {
      name: "Customer",
      selector: (row) => {
        try {
          const address = row.addresses?.length
            ? row.addresses.reduce((a, b) => new Date(a.created_at) > new Date(b.created_at) ? a : b) : {};
    
          return (
            <div className="dprofile">
              <img src={IMG.DP} alt="dp" />
              <div className="items">
                <span className="name fw-600">{`${address?.fname ? address.fname + '' + address.lname : row.name}`}</span>
                <span className="email text-neutral-dark-200 fs-xs">{row.email}</span>
                {/* <span className="phone text-neutral-dark-200 fs-xs">{address.phone}</span> */}
              </div>
            </div>
          );
        } catch (error) {
          return <span>N/A</span>;
        }
      },
      
      width: "250px",
    },
    {
      name: "Location",
      selector: (row) => {
        try {
          const address = row.addresses?.length
            ? row.addresses.reduce((a, b) => new Date(a.created_at) > new Date(b.created_at) ? a : b) : {};
    
          return (
            <div className="text-neutral-dark-800 fw-400 fs-sm text-wrap">
              {`${address.city}, ${address.state.name}`}
            </div>
          );
        } catch (error) {
          return <span className="text-neutral-dark-200 fs-sm">N/A</span>;
        }
      },
      
      width: "250px",
    },
    {
      name: "Summary",
      selector: (row) => (
       <>
         <div className="d-flex grid-gap-4 fs-xs">
            <span className="text-neutral-dark-400 fw-500">Order Count: </span>
            <span className="text-neutral-dark-600 fw-600">{row.orders_count}</span>
          </div>
          <div className="d-flex grid-gap-4">
            <span className="text-neutral-dark-400 fw-500">Total Value: </span>
            <span className="text-neutral-dark-600 fw-600">{row.orders_sum ? '₹'+row.orders_sum : '₹0.00'}</span>
          </div>
       </>
      ),
      width: "200px"
    },
    {
      name: "Joined Since",
      selector: (row) => (
        <span className="text-neutral-dark-600 fs-sm">{formattedDate(row.created_at)}, <br /> {formattedTime(row.created_at)}</span>
      )
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="actionsWrapper">
          <div onClick={() => handleView(row.id)}>
            <RiEyeLine />
          </div>
          <div onClick={() => handleEdit(row.id)}>
            <RiEdit2Line /> 
          </div>
          <div onClick={() => handleDelete(row.id)}>
            <RiDeleteBin6Line />
          </div>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      {loader && <p>Loading...</p>}
      {errors && <p style={{ color: "red" }}>Error: {errors}</p>}
      {!loader && !errors && (
        <div className="ContainerBox">
          <CustomDataTable columns={columns} data={customers} title="All Customers" />
        </div>
      )}
    </div>
  );
};

export default Customers;
